import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import axios from "axios";
import BackGroundColor from "../CommanComponents/BackGroundColor";

function Forgotpassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const submit = async (values, { resetForm }) => {
    console.log(values, "emai");
    setLoading(true);
    try {
      const res = await axios.post(
        import.meta.env.VITE_REACT_APP_SERVER_URL + "forgot-password",
        { email: values.email },
      );

      if (res.status === 200) {
        alert(
          "Şifre sıfırlama bağlantısı mail adresinize gönderildi. Lütfen kontrol edin.",
        );
        navigate("/login"); // Kullanıcıyı tekrar login sayfasına yönlendir
      }
    } catch (error) {
      alert(error.response?.data?.message || "Bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  const { values, errors, touched, handleChange, handleSubmit } = useFormik({
    initialValues: {
      email: "", // Şifre ve verify alanlarına burada gerek yok
    },
    onSubmit: submit,
  });
  return (
    <div
      className="min-h-screen flex flex-col justify-center items-center
     bg-yellow-100 relative overflow-hidden"
    >
      {/* Fun Background Elements */}
      <BackGroundColor />
      {/* Content */}
      <div className="z-10 bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex flex-col items-center mb-6">
          <h1 className="text-3xl text-blue-600 font-bold mb-2">
            My Classroom
          </h1>
          <p className="text-lg text-purple-500 font-semibold">
            Reset Password
          </p>
        </div>

        <div className="w-full">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col justify-center items-center p-4 gap-6">
              <div className="flex flex-col gap-2 w-full">
                <label
                  htmlFor="email"
                  className="block text-lg font-bold text-orange-500"
                >
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  className="w-full h-12 text-xl rounded-full px-4 outline-none border-2
                   border-purple-300 focus:border-purple-500"
                  placeholder="your-email@example.com"
                />
              </div>
              <div className="flex justify-end ml-64 ">
                <button
                  onClick={() => navigate("/login")}
                  className="text-blue-500 hover:text-blue-700"
                  type="button"
                >
                  <span>login</span>
                </button>
              </div>
              <div className="w-full mt-4">
                <button
                  className="bg-green-500 hover:bg-green-600 text-white 
                  text-xl font-bold rounded-full w-full h-12 transition-colors duration-300 flex items-center justify-center"
                  type="submit"
                >
                  Kod Gönder
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Forgotpassword;
